import { SetupPage } from "./pages/SetupPage";
import { LoginPage } from "./pages/LoginPage";
import { URLShortenerPage } from "./pages/URLShortenerPage"; 
import { CalendarPage } from "./pages/CalendarPage"; 
import { Routes, Route, Outlet } from "react-router-dom";
import { RmSidebar } from "./RmSidebar";
import { SiteHeader } from "./SiteHeader";
import { SpotPage } from "./pages/SpotPage";
import { EventsPage } from "./pages/EventsPage";

function AppLayout() {
  return (
    <>
      <SiteHeader />
      <div className="page-content flex">
        <RmSidebar />  
        <main className="w-full pl-4">
          <Outlet /> 
        </main>
      </div>
    </>
  )
}

function LoginPageLayout() {
  return (
    <div className="h-screen w-screen flex items-center justify-center">
      <LoginPage />
    </div>
  )
}

const App = () => {
  return (
    <Routes>
      <Route path="/auth" element={<LoginPageLayout />} >
      </Route>
      <Route path="/" element={<AppLayout />}>
        <Route index element={<EventsPage />} />
        <Route path="events" element={<EventsPage />} />
        <Route path="event" element={<SetupPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="shortener" element={<URLShortenerPage />} />
      </Route>
    </Routes>
  );
};

export default App;
